import React, { Component } from "react";

class HeaderTags extends Component {
    constructor(props) {
        super(props);
        this.state = {
            location: this.props.location,
            page: this.props.page,
            dashboards:[
                { id: 1, name: 'New Appointments', page: 1 },
                { id: 2, name: 'Confirmed Appointments', page: 1 },
                { id: 3, name: 'Documents Pending', page: 1 },
                { id: 4, name: 'Partial Documents Submitted', page: 1 },
                { id: 5, name: 'Documents Submitted', page: 1 },
                { id: 6, name: 'Settled', page: 1 },
                { id: 7, name: 'Cancelled', page: 1 },
                { id: 8, name: 'Rejected', page: 1 },
                { id: 9, name: 'Not Attended', page: 1 },
            ]
        }
        let x = this.state.location.split('/')[3] ? this.state.location.split('/')[3] : null;

           this.checkTheDashboard(x);
    }

    assignDashboard(id, name, pageNo) {
        let obj = JSON.parse(localStorage.getItem("pageTracking"))
        if(!obj)
            obj ={}
        let rows = null;
        if(window.location.hash === localStorage.getItem("req")){
            rows = JSON.parse(localStorage.getItem("pageTracking")).totalRows
        }
        localStorage.setItem("pageTracking",JSON.stringify({
            ...obj,
            id:id,
            name:name,
            page:pageNo,
            totalRows:rows
        }))
        this.setState({
            id:id,
            name:name,
            page:pageNo
        })
    }

    checkTheDashboard(path,test=null) {
        switch (path) {
            case "confirmed": this.assignDashboard(2, "Confirmed Appointments", test?test:this.props.page); break;
            case "pending": this.assignDashboard(3, "Documents Pending", test?test:this.props.page); break;
            case "partialReceived": this.assignDashboard(4, "Partial Documents Pending", test?test:this.props.page); break;
            case "received": this.assignDashboard(5, "Documents Submitted", test?test:this.props.page); break;
            case "settled": this.assignDashboard(6, "Settled", test?test:this.props.page); break;
            case "cancelled": this.assignDashboard(7, "Cancelled", test?test:this.props.page); break;
            case "rejected": this.assignDashboard(8, "Rejected", test?test:this.props.page); break;
            case "notAttended": this.assignDashboard(9, "Not Attended", test?test:this.props.page); break;
            default: this.assignDashboard(1, "New Appointments", test?test:this.props.page); break;
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setState({
                location: this.props.location 
            }, () => {
                let x = this.props.location.split('/')[3] ? this.props.location.split('/')[3] : null;
                // if(!(this.props.location.pathname.includes("history") || prevProps.location.pathname.includes("history")))
                    this.checkTheDashboard(x)
            });
        }
        if (this.props.page !== prevProps.page) {
            this.setState({
                page: this.props.page
            }, () => {
                let x = this.props.location.split('/')[3] ? this.props.location.split('/')[3] : null;
                this.checkTheDashboard(x)
            });
        }
    }

    clickRouteToReceivedDocuments(id) {
        this.props.resetFilter();
        this.RouteToReceivedDocuments(id);
    }
    RouteToReceivedDocuments(id) {
        switch (id) {
            case 1: this.props.history.push("/" + localStorage.getItem("roleName") + "/appointments/"); break;
            case 2: this.props.history.push("/" + localStorage.getItem("roleName") + "/appointments/confirmed"); break;
            case 3: this.props.history.push("/" + localStorage.getItem("roleName") + "/documents/pending"); break;
            case 4: this.props.history.push("/" + localStorage.getItem("roleName") + "/documents/partialReceived"); break;
            case 5: this.props.history.push("/" + localStorage.getItem("roleName") + "/documents/received"); break;
            case 6: this.props.history.push("/" + localStorage.getItem("roleName") + "/cases/settled"); break;
            case 7: this.props.history.push("/" + localStorage.getItem("roleName") + "/cases/cancelled"); break;
            case 8: this.props.history.push("/" + localStorage.getItem("roleName") + "/cases/rejected"); break;
            case 9: this.props.history.push("/" + localStorage.getItem("roleName") + "/appointments/notAttended"); break;
            default: this.props.history.push("/" + localStorage.getItem("roleName") + "/appointments/"); break;
        }
    }


    render() {
        return (
            <div className="pb-10">
                <div className="table tabColor w-full text-sm">
                    {
                        this.state.dashboards.map((elem, index) =>{
                            let id = JSON.parse(localStorage.getItem("pageTracking")).id
                            return(
                            <div key={elem.id} className={(elem.id=== id ? (index === 0) ? 'table-cell text-center bg-white rounded-tr-xl font-semibold' : (index === this.state.dashboards.length - 1) ? 'table-cell text-center bg-white  rounded-tl-xl font-semibold' : 'table-cell text-center bg-white  rounded-t-xl font-semibold' : 'table-cell text-center')} onClick={() => this.clickRouteToReceivedDocuments(elem.id)}>
                                <div className={(elem.dashboardShown ? 'px-2 py-4 text-gray-900 cursor-pointer rounded rounded-t-xl' : 'px-2 py-4 text-gray-500 cursor-pointer')}>
                                    <div className={(elem.dashboardShown ? 'hover:text-gray-600' : 'hover:text-gray-800')}>{elem.name}</div>
                                </div>
                            </div>
                        )})
                    }
                </div>
            </div>
        );
    }

}

export default HeaderTags;